import Route from '@ember/routing/route';
import { get, set } from '@ember/object';
import { service } from '@ember/service';
import lookupValidator from 'ember-changeset-validations';
import Changeset from 'ember-changeset';
import { validatePresence } from 'ember-changeset-validations/validators';

const createGroupValidation = {
  name: validatePresence({ presence: true, message: "Can't be blank" }),
};

export default Route.extend({
  contactsCache: service(),
  navbarSettings: service(),

  queryParams: {
    groupName: {
      refreshModel: true,
    },
    contactIds: {
      refreshModel: true,
    },
  },

  beforeModel() {
    set(this, 'navbarSettings.title', 'Create Group');
  },

  model(params) {
    let changeset = new Changeset(
      {},
      lookupValidator(createGroupValidation),
      createGroupValidation,
    );
    let contactIds = params.contactIds.split('-');
    let contactsCache = this.contactsCache;
    let contacts = contactIds.map((id) => {
      return get(contactsCache, `contactsById.${id}`);
    });
    return {
      groupName: params.groupName,
      contacts,
      changeset,
    };
  },

  resetController(controller, isExiting) {
    if (isExiting) {
      controller.reset();
    }
  },
});
